import { TFunction } from 'i18next';
import { Sector } from 'graphql-common';
import Icons from '@lib/components/Icons/Icons';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import _get from 'lodash/get';
import { TooltipProps } from '@lib/components/Tooltip/Tooltip';

type ActionsMenuArgs = {
  isViewOnly: boolean;
  onDeleteHandler: (v?: Sector) => void;
  onEditHandler: (v?: Sector) => void;
  onViewHandler: (v?: Sector) => void;
  t: TFunction<'translation', undefined>;
};

export default function getTableActionsMenu({
  isViewOnly,
  onDeleteHandler,
  onEditHandler,
  onViewHandler,
  t,
}: ActionsMenuArgs): NavItem<Sector>[] {
  return [
    {
      id: 'view-action',
      title: t('view'),
      leftIcon: Icons.view,
      onClick: (item?: Sector) => onViewHandler(item),
      type: NavItemTypeEnum.Secondary,
    },
    {
      id: 'edit-action',
      title: t('edit'),
      leftIcon: Icons.edit,
      onClick: (item?: Sector) => onEditHandler(item),
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: () => !isViewOnly,
      predictorFnDisable: (item?: Sector) => !!item?.readOnly,
      predictorFnDisableTooltipProps: (item?: Sector) =>
        item?.readOnly
          ? ({
              body: t('sector-default-disabled-edit-desc'),
              placement: 'left',
            } as Omit<TooltipProps, 'children'>)
          : undefined,
    },
    {
      id: 'delete-action',
      title: t('delete'),
      leftIcon: Icons.delete,
      onClick: (item?: Sector) => onDeleteHandler(item),
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: () => !isViewOnly,
      predictorFnDisable: (item?: Sector) =>
        _get(item, 'canDestroy.value', true) === false || !!item?.readOnly,
      predictorFnDisableTooltipProps: (item?: Sector) => {
        if (item?.readOnly) {
          return {
            body: t('sector-default-disabled-destroy-desc'),
            placement: 'left',
          };
        }
        if (!item?.canDestroy?.value) {
          return {
            body: t('sector-disabled-destroy-desc'),
            placement: 'left',
          };
        }
        return undefined;
      },
    },
  ];
}
